import { DisplayTime } from '@tock/time';
import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import React, { FC } from 'react';

const SoldOutText: React.FC<{ isSoldOut: boolean }> = ({ isSoldOut }) => {
  return isSoldOut ? <span> (Sold out)</span> : null;
};

const SeatingAreasDisplay: React.FC<{ seatingAreas: core.IAvailabilitySeatingArea[] }> = ({
  seatingAreas,
}) => {
  if (seatingAreas.length === 0) {
    return null;
  }
  return (
    <Typography variant="body02" color="fgSubtle">
      {seatingAreas.map(({ name }) => name).join(' · ')}
    </Typography>
  );
};

const HelperTextDisplay: React.FC<{ text: string }> = ({ text }) => {
  if (text === '') {
    return null;
  }
  return (
    <Typography variant="body02" color="fgSubtle">
      {text}
    </Typography>
  );
};

// Exported for testing
export interface BookingCardLeftContentProps {
  helperText?: string;
  isAvailable: boolean;
  isRescheduling: boolean;
  isShipping: boolean;
  matchesUserLockedDateTime: boolean;
  seatingAreas: core.IAvailabilitySeatingArea[];
  showNotifyLink: boolean;
  soldOutCondition: boolean;
  time: string;
  waitlistUrl: string;
}

export const BookingCardLeftContent: FC<BookingCardLeftContentProps> = ({
  helperText = '',
  isAvailable,
  isShipping,
  matchesUserLockedDateTime,
  seatingAreas = [],
  showNotifyLink,
  soldOutCondition,
  time,
  waitlistUrl,
}) => {
  const typographyVariant = 'body01Strong';

  return (
    <>
      {isShipping && time && (
        <span className="Consumer-resultsListItemTime" data-testid="search-result-time">
          <Typography
            color={showNotifyLink && waitlistUrl ? 'fgSubtle' : 'fgDefault'}
            variant={typographyVariant}
            component="span"
          >
            {isAvailable && 'Order now'}
            <SoldOutText isSoldOut={!matchesUserLockedDateTime && soldOutCondition} />
          </Typography>
        </span>
      )}
      {!isShipping && time && (
        <span className="Consumer-resultsListItemTime" data-testid="search-result-time">
          <Typography
            component="span"
            color={soldOutCondition ? 'fgSubtle' : 'inherit'}
            variant={typographyVariant}
          >
            <DisplayTime timeValue={time} />
          </Typography>
          <SeatingAreasDisplay seatingAreas={seatingAreas} />
          <HelperTextDisplay text={helperText} />
        </span>
      )}
    </>
  );
};
